import React, { useEffect, useState } from "react";
import { db } from "../firebase/db";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";

const PublicProfileFeed: React.FC = () => {
  const [users, setUsers] = useState<{ id: string; username: string }[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getDocs(collection(db, "users")).then(snap => {
      setUsers(
        snap.docs.map(doc => ({
          id: doc.id,
          username: doc.data().username || doc.data().displayName || doc.data().email || doc.id,
        }))
      );
    });
  }, []);

  const filtered = users.filter(u =>
    u.username.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="bg-blue-100 min-h-screen w-full">
      <div className="max-w-2xl mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Friends</h1>
        <input
          className="border rounded px-2 py-1 mb-4 w-full"
          placeholder="Search users..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <ul>
          {filtered.map(user => (
            <li key={user.id} className="mb-2">
              <Link
                to={`/profiles/${user.id}`}
                className="text-indigo-700 hover:underline"
              >
                {user.username}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PublicProfileFeed;